export const ConfigNavbar = {
  portal: {
    logo: "home",
    pathHome: "/",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "HomeLogo",
  },
  facesign: {
    logo: "home",
    pathHome: "/facesign",
    name: "FaceSign",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: true,
    logoText: "FaceSignLogo",
  },
  accord: {
    logo: "home",
    pathHome: "/accord",
    name: "Accord",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: true,
    logoText: "AccordTexto",
  },
  getdata: {
    logo: "getdata",
    pathHome: "/getdata",
    name: "GetData",
    services: [
      {
        icon: "sync",
        label: "DTESync",
        action: "/getdata/api",
      },
      {
        icon: "airplay",
        label: "Connect",
        action: "/setup/connections",
      },
      {
        icon: "description",
        label: "CTE",
      },
    ],
    companies: [
      {
        country: "CL",
        name: "76308  ELASBIT SPA",
      },
      {
        country: "PE",
        name: "76308539-2  ELASBIT SPA",
      },
    ],
    stages: true,
    subscriptions: true,
    custom: true,
    logoText: "GetDataTexto",
  },
  jscipher: {
    logo: "Jscypher",
    pathHome: "/",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "",
  },
  vizdata: {
    logo: "vizdata",
    pathHome: "/vizdata",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "VizdataTexto",
  }, 
  fleet: {
    logo: "rules",
    pathHome: "/fleet",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "RulesTexto",
  },
  lendbot: {
    logo: "lendbot",
    pathHome: "/lendbot",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "LendbotTexto",
  },
  setting: {
    logo: "admin",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "AdminLogo",
  },
  profile: {
    logo: "HomeLogo",
    pathHome: "/profile",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "HomeLogo",
  },
  consents: {
    logo: "Consent",
    pathHome: "/consents",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "ConsentTexto",
  },
  tous: {
    logo: "Tou",
    pathHome: "/tous",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "TouTexto",
  },
  markdownEditor: {
    logo: "",
    pathHome: "/tous/clauseditor",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "",
  },
  connect: {
    logo: "Connect",
    pathHome: "/connect",
    services: "",
    companies: "",
    stages: false,
    subscriptions: false,
    custom: false,
    logoText: "ConnectTexto",
  },  
};
